import { render, staticRenderFns } from "./ForfeitureOfShares.vue?vue&type=template&id=500f7c6e&scoped=true&"
import script from "./ForfeitureOfShares.vue?vue&type=script&lang=js&"
export * from "./ForfeitureOfShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500f7c6e",
  null
  
)

export default component.exports